import { Outlet } from "react-router-dom";
import { useUnauthorizedRedirect } from "@/hooks/use-unauthorized-redirect";
import Sidebar from "@/components/Sidebar";
import { Toaster } from "react-hot-toast";

export default function TabLayout() {
  useUnauthorizedRedirect();

  // Removed duplicate instant-call-request listener - handled in main layout

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar />
      <main className="transition-all duration-300 md:pl-64 ">
        <div className="max-w-7xl mx-auto">
          <Outlet />
        </div>
      </main>
      <Toaster />
    </div>
  );
}
